
import { Union } from "./fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { string_type, union_type } from "./fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { ofNullable } from "./fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { singleton, map, ofArray, exists } from "./fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { createObj, defaultOf, equals } from "./fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { UserNotificationSettingsDto_$reflection, NotificationChannel } from "./Shared/NotificationSettings.js";
import { join, concat } from "./fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { getToken, getMessaging } from "firebase/messaging";
import { initializeApp, getApps } from "firebase/app";
import { item, equalsWith } from "./fable_modules/fable-library-js.5.0.0-rc.2/Array.js";
import { WebPushConfigurationDto_$reflection, WebDeviceTokenDto_$reflection, WebDeviceTokenDto } from "./Shared/WebPush.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "./fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "./fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "./fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix, fetchWithDecoderWithoutErrorPage } from "./CommunicationV2.js";
import { Types_HttpRequestHeaders, Types_RequestProperties } from "./fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "./fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { Cmd_OfPromise_either } from "./fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { ValidationOnGetRequest } from "./ErrorHandling.js";
import { currentAccessToken } from "./Auth.js";
import { keyValueList } from "./fable_modules/fable-library-js.5.0.0-rc.2/MapUtil.js";
import { singleton as singleton_1, empty, append, delay, toList } from "./fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";

export class Permission extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Unsupported", "Default", "Denied", "Granted"];
    }
}

export function Permission_$reflection() {
    return union_type("WebPush.Permission", [], Permission, () => [[], [], [], []]);
}

export class Activation extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Registered", "NotGranted", "RegistrationFailed"];
    }
}

export function Activation_$reflection() {
    return union_type("WebPush.Activation", [], Activation, () => [[], [["Item", Permission_$reflection()]], []]);
}

const tokenKey = "webPushToken";

const serviceWorkerPath = "/firebase-messaging-sw.js";

const configurationUrl = "/api/users/me/web-push/configuration";

const registerUrl = "/api/users/me/device-tokens";

const unregisterUrl = "/api/users/me/device-tokens/unregister";

const notificationSettingsUrl = "/api/users/notification-settings";

export function storedToken() {
    return ofNullable(localStorage.getItem(tokenKey));
}

function storeToken(token) {
    localStorage.setItem(tokenKey, token);
}

function forgetToken() {
    localStorage.removeItem(tokenKey);
}

export function permission() {
    if (!(typeof Notification !== 'undefined' && typeof navigator !== 'undefined' && 'serviceWorker' in navigator && 'PushManager' in window)) {
        return new Permission(0, []);
    }
    else {
        const matchValue = Notification.permission;
        switch (matchValue) {
            case "granted":
                return new Permission(3, []);
            case "denied":
                return new Permission(2, []);
            default:
                return new Permission(1, []);
        }
    }
}

export function isNeeded(cells) {
    return exists((cell) => {
        if (equals(cell.Channel, new NotificationChannel(2, []))) {
            return cell.Effective;
        }
        else {
            return false;
        }
    }, cells);
}

function firebaseOptions(configuration) {
    return ofArray([["apiKey", configuration.ApiKey], ["projectId", configuration.ProjectId], ["messagingSenderId", configuration.MessagingSenderId], ["appId", configuration.AppId]]);
}

function serviceWorkerUrl(configuration) {
    return concat(serviceWorkerPath, "?", ...join("&", map((tupledArg) => concat(tupledArg[0], "=", ...encodeURIComponent(tupledArg[1])), firebaseOptions(configuration))));
}

function messaging(configuration) {
    let matchValue;
    return getMessaging((matchValue = getApps(), (!equalsWith(equals, matchValue, defaultOf()) && (matchValue.length === 0)) ? initializeApp(createObj(map((tupledArg) => [tupledArg[0], tupledArg[1]], firebaseOptions(configuration)))) : item(0, matchValue)));
}

function requestToken(configuration) {
    const pr = navigator.serviceWorker.register(serviceWorkerUrl(configuration));
    return pr.then((registration) => getToken(messaging(configuration), {
        vapidKey: configuration.VapidKey,
        serviceWorkerRegistration: registration,
    }));
}

function tokenBody(token) {
    const value = new WebDeviceTokenDto(token);
    return toString(0, Auto_generateBoxedEncoder_437914C6(WebDeviceTokenDto_$reflection(), undefined, undefined, undefined)(value));
}

function register(token) {
    let pr_1;
    const body = tokenBody(token);
    pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoderWithoutErrorPage(addPrefix(registerUrl), ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [body])]), "application/json", (response) => {
        const pr = response.arrayBuffer();
        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
    }))));
    return pr_1.then((response_2) => {
        if (response_2.tag === 1) {
            return new Activation(2, []);
        }
        else {
            storeToken(token);
            return new Activation(0, []);
        }
    });
}

function registerIfGranted(configuration) {
    const matchValue = permission();
    let matchResult, permission_1;
    switch (matchValue.tag) {
        case 0: {
            matchResult = 1;
            permission_1 = matchValue;
            break;
        }
        case 1: {
            matchResult = 1;
            permission_1 = matchValue;
            break;
        }
        case 2: {
            matchResult = 1;
            permission_1 = matchValue;
            break;
        }
        default:
            matchResult = 0;
    }
    switch (matchResult) {
        case 0: {
            const pr = requestToken(configuration);
            return pr.then(register);
        }
        default:
            return Promise.resolve(new Activation(1, [permission_1]));
    }
}

export function activate(configuration) {
    const matchValue = permission();
    switch (matchValue.tag) {
        case 3:
            return registerIfGranted(configuration);
        case 1:
        case 2: {
            let pr_1;
            const pr = new Promise(function (resolve) { resolve(Notification.requestPermission()); });
            pr_1 = (pr.then(void 0, ((_arg) => "default")));
            return pr_1.then((_arg_1) => registerIfGranted(configuration));
        }
        default:
            return Promise.resolve(new Activation(1, [new Permission(0, [])]));
    }
}

export function Cmd_getConfiguration(successMsg, errorMsg) {
    return Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_2;
        return ((url_2 = addPrefix(url), (refreshOn) => fetchWithDecoder(url_2, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), WebPushConfigurationDto_$reflection()));
        }, refreshOn)))(true).then((_arg) => {
            const result_1 = _arg;
            return (result_1.tag === 1) ? (Promise.resolve((() => {
                throw new ValidationOnGetRequest(result_1.fields[0]);
            })())) : (Promise.resolve(result_1.fields[0]));
        });
    })), configurationUrl, successMsg, errorMsg);
}

export function Cmd_activate(configuration, successMsg, errorMsg) {
    return Cmd_OfPromise_either(activate, configuration, successMsg, errorMsg);
}

function activateWhenNeeded(configuration) {
    const pr_2 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoderWithoutErrorPage(addPrefix(notificationSettingsUrl), singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
        const pr = response.arrayBuffer();
        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), UserNotificationSettingsDto_$reflection()));
    }).then((_arg) => {
        const result_1 = _arg;
        return (result_1.tag === 1) ? (Promise.resolve((() => {
            throw new ValidationOnGetRequest(result_1.fields[0]);
        })())) : (Promise.resolve(result_1.fields[0]));
    }))));
    return pr_2.then((settings) => {
        if (isNeeded(settings.Cells)) {
            const pr_1 = activate(configuration);
            return pr_1.then((value) => {
            });
        }
        else {
            return Promise.resolve(undefined);
        }
    });
}

export function activateIfNeeded() {
    const matchValue = permission();
    switch (matchValue.tag) {
        case 0:
        case 2: {
            break;
        }
        default: {
            let pr_3;
            let pr_2;
            const pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoderWithoutErrorPage(addPrefix(configurationUrl), singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
                const pr = response.arrayBuffer();
                return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), WebPushConfigurationDto_$reflection()));
            }).then((_arg) => {
                const result_1 = _arg;
                return (result_1.tag === 1) ? (Promise.resolve((() => {
                    throw new ValidationOnGetRequest(result_1.fields[0]);
                })())) : (Promise.resolve(result_1.fields[0]));
            }))));
            pr_2 = (pr_1.then((dto) => {
                const matchValue_1 = dto.Configuration;
                if (matchValue_1 == null) {
                    return Promise.resolve(undefined);
                }
                else {
                    return activateWhenNeeded(matchValue_1);
                }
            }));
            pr_3 = (pr_2.then(void 0, ((value) => {
            })));
            pr_3.then();
        }
    }
}

export function unregisterOnLogout() {
    const matchValue = storedToken();
    if (matchValue != null) {
        const token = matchValue;
        forgetToken();
        const accessToken = currentAccessToken();
        const tenant = ofNullable(localStorage.getItem("tenant"));
        const init = {
            method: "POST",
            body: tokenBody(token),
            headers: keyValueList(toList(delay(() => {
                let matchValue_1;
                return append((matchValue_1 = accessToken, (matchValue_1 == null) ? (empty()) : singleton_1(new Types_HttpRequestHeaders(5, ["Bearer " + matchValue_1]))), delay(() => append(singleton_1(new Types_HttpRequestHeaders(11, ["application/json"])), delay(() => {
                    const matchValue_2 = tenant;
                    if (matchValue_2 == null) {
                        return empty();
                    }
                    else {
                        return singleton_1(["X-ONE-Tenant", matchValue_2]);
                    }
                }))));
            })), 0),
        };
        init.keepalive = true;
        let pr_2;
        let pr_1;
        const pr = fetch(addPrefix(unregisterUrl), init);
        pr_1 = (pr.then((value_1) => {
        }));
        pr_2 = (pr_1.then(void 0, ((_arg) => {
        })));
        pr_2.then();
    }
}

